import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Calendar, BookOpen, ArrowRight } from 'lucide-react';

const HomepageHero = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center bg-primary-deep overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-white rounded-full blur-xl"></div>
        <div className="absolute bottom-40 right-20 w-48 h-48 bg-white rounded-full blur-xl"></div>
        <div className="absolute top-1/2 left-1/3 w-24 h-24 bg-white rounded-full blur-xl"></div>
        <div className="absolute top-1/3 right-1/4 w-36 h-36 bg-white rounded-full blur-xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10 pt-24 md:pt-20">
        <div className="text-center max-w-5xl mx-auto">
          {/* Main headline */}
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight drop-shadow-lg">
            Prana Kundalini
            <span className="block text-primary-light">Akademie</span>
          </h1>
          
          {/* Subtitle */}
          <div className="mb-8">
            <h2 className="text-xl md:text-2xl text-white mb-4 font-medium drop-shadow-md">
              Ganzheitliche Spirituelle Ausbildung und Energetiker Ausbildung
            </h2>
            <p className="text-lg text-white max-w-3xl mx-auto drop-shadow-md">
              in der Berufsgruppe Humanenergetiker in 5 Modulen der 
              <strong className="text-primary-light"> "Prana Kundalini-Therapie®"</strong> - 
              die wohl effektivste spirituelle und energetische Praxis, die es gibt.
            </p>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
            <Button 
              size="lg" 
              asChild
              className="bg-primary-light hover:bg-primary-light/80 hover:scale-105 text-primary-deep font-semibold px-8 py-4 text-lg shadow-xl border-2 border-primary-light transition-all duration-200"
            >
              <Link to="/anmeldung">
                <Calendar className="mr-2 h-5 w-5" />
                Jetzt Anmelden
              </Link>
            </Button>
            
            <Button 
              size="lg" 
              variant="outline" 
              asChild
              className="border-2 border-white bg-white text-primary-deep hover:bg-primary-lightest hover:text-primary-deep hover:scale-105 font-semibold px-8 py-4 text-lg shadow-xl transition-all duration-200"
            >
              <Link to="/module">
                <BookOpen className="mr-2 h-5 w-5" />
                Module Entdecken
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
            </Button>
          </div>

          {/* Quick info cards with hover effects and bottom margin to prevent touching next section */}
          <div className="grid md:grid-cols-3 gap-6 max-w-4xl mx-auto mb-8">
            <div className="p-4 text-center bg-primary-lightest rounded-lg shadow-xl border border-primary-lightest hover:shadow-2xl hover:scale-105 transition-all duration-200 cursor-pointer">
              <div className="text-3xl font-bold text-primary-deep mb-2">5</div>
              <p className="text-primary-deep font-medium">Module</p>
            </div>
            
            <div className="p-4 text-center bg-primary-lightest rounded-lg shadow-xl border border-primary-lightest hover:shadow-2xl hover:scale-105 transition-all duration-200 cursor-pointer">
              <div className="text-3xl font-bold text-primary-deep mb-2">2</div>
              <p className="text-primary-deep font-medium">Semester pro Jahr</p>
            </div>
            
            <div className="p-4 text-center bg-primary-lightest rounded-lg shadow-xl border border-primary-lightest hover:shadow-2xl hover:scale-105 transition-all duration-200 cursor-pointer">
              <div className="text-3xl font-bold text-primary-deep mb-2">✓</div>
              <p className="text-primary-deep font-medium">Zertifiziert</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomepageHero;